var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 26.4783C21.1154 26.4783 26.4783 21.1154 26.4783 14.5C26.4783 7.88459 21.1154 2.52174 14.5 2.52174C7.88459 2.52174 2.52174 7.88459 2.52174 14.5C2.52174 21.1154 7.88459 26.4783 14.5 26.4783ZM14.5 29C22.5081 29 29 22.5081 29 14.5C29 6.49187 22.5081 0 14.5 0C6.49187 0 0 6.49187 0 14.5C0 22.5081 6.49187 29 14.5 29Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4887 10.9714C15.1654 10.9714 15.7218 10.7434 16.1579 10.2875C16.579 9.81406 16.7895 9.23538 16.7895 8.55149C16.7895 7.85006 16.579 7.27138 16.1579 6.81545C15.7218 6.34199 15.1654 6.10526 14.4887 6.10526C13.8271 6.10526 13.2857 6.34199 12.8647 6.81545C12.4286 7.27138 12.2105 7.85006 12.2105 8.55149C12.2105 9.23538 12.4286 9.81406 12.8647 10.2875C13.2857 10.7434 13.8271 10.9714 14.4887 10.9714ZM12.5714 13V22.8947H16.4286V13H12.5714Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.f12561b28dc97d77e9440ead78f5ae27.svg";
export { ForwardRef as ReactComponent };